'use client';
import styled from 'styled-components';

const ColumnHeader = styled.div`
  padding: 24px 24px 16px;
`;

export default ColumnHeader;
